import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEye,
  faCircleUser,
  faStar,
  faNoteSticky,
  faBuilding,
  faTrashCan,
  faPenToSquare,
  faLightbulb,
  faFolderOpen,
  faCircleXmark,
  faCopy,
  faUser as faUserRegular,
  faHand,
  faImage,
  faCircle as faCircleRegular,
  faSquare,
  faCircleQuestion,
  faCheckSquare,
} from '@fortawesome/free-regular-svg-icons';
import {
  faCoffee,
  faCircle,
  faBars,
  faArrowRight,
  faChevronDown,
  faGlobe,
  faXmark,
  faPaperclip,
  faCheck,
  faFilter,
  faFileImport,
  faArchive,
  faFolder,
  faEyeSlash,
  faAnglesLeft,
  faAnglesRight,
  faUserGroup,
  faWrench,
  faArrowDown,
  faArrowUpFromBracket,
  faEllipsisVertical,
  faGrip,
  faArrowUpRightFromSquare,
  faShareNodes,
  faAngleLeft,
  faAngleRight,
  faTriangleExclamation,
  faCheckCircle,
  faExclamationCircle,
  faRotateLeft,
  faRotateRight,
  faCheckDouble,
  faUpDown,
  faICursor,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faAlignLeft,
  faAlignRight,
  faAlignCenter,
  faArrowRightLong,
  faCropSimple,
  faStar as faStarSolid,
  faCircleHalfStroke,
  faMinus,
  faPlus,
  faCirclePlus,
  faBarsStaggered,
  faAngleDown,
  faBoxArchive,
  faChevronRight,
  faChevronUp,
  faDownload,
  faLeftRight,
  faArrowsLeftRight,
  faUpload,
  faCloudUpload,
  faFileExport,
  faUpRightFromSquare,
  faCrown,
  faScissors,
  faCaretDown,
  faPrint,
  faArrowLeft,
  faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons';
import { config } from '@fortawesome/fontawesome-svg-core';
import {
  faGoogle,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
  faXTwitter,
  faWhatsapp,
  faDropbox,
  faGoogleDrive,
} from '@fortawesome/free-brands-svg-icons';
import '@fortawesome/fontawesome-svg-core/styles.css';

config.autoAddCss = false;

faUserRegular.prefix = 'far';
faCircleRegular.prefix = 'far';
faStarSolid.prefix = 'fas';
faTrashCan.prefix = 'far';

library.add(
  faDownload,
  faCircleXmark,
  faCoffee,
  faCircle,
  faBars,
  faUserRegular,
  faArrowRight,
  faChevronDown,
  faChevronUp,
  faCircleUser,
  faInstagram,
  faCircleXmark,
  faChevronRight,
  faLinkedinIn,
  faYoutube,
  faFacebookF,
  faXTwitter,
  faGlobe,
  faXmark,
  faPaperclip,
  faCheck,
  faFilter,
  faWhatsapp,
  faFileImport,
  faFolder,
  faArchive,
  faDropbox,
  faGoogleDrive,
  faEyeSlash,
  faEye,
  faGoogle,
  faAnglesLeft,
  faAnglesRight,
  faStar,
  faUserGroup,
  faNoteSticky,
  faBuilding,
  faWrench,
  faTrashCan,
  faArrowDown,
  faLightbulb,
  faArrowUpFromBracket,
  faEllipsisVertical,
  faGrip,
  faArrowUpRightFromSquare,
  faShareNodes,
  faPenToSquare,
  faAngleLeft,
  faAngleRight,
  faFolderOpen,
  faCircleXmark,
  faTriangleExclamation,
  faCheckCircle,
  faExclamationCircle,
  faRotateLeft,
  faRotateRight,
  faCheckDouble,
  faUpDown,
  faCopy,
  faHand,
  faICursor,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faAlignLeft,
  faAlignRight,
  faAlignCenter,
  faImage,
  faCircleRegular,
  faSquare,
  faArrowRightLong,
  faCropSimple,
  faStarSolid,
  faCircleHalfStroke,
  faMinus,
  faPlus,
  faCirclePlus,
  faStarSolid,
  faBarsStaggered,
  faAngleDown,
  faBoxArchive,
  faArrowsLeftRight,
  faCircleQuestion,
  faLeftRight,
  faArrowsLeftRight,
  faCheckSquare,
  faUpload,
  faCloudUpload,
  faFileExport,
  faUpRightFromSquare,
  faCrown,
  faScissors,
  faCaretDown,
  faPrint,
  faArrowLeft,
  faMagnifyingGlass
);
